<template>
  <div class="min-w-1000px">
    <PageHeader title="物件概要書" class="list">
      <template #title-header-content>
        <div class="flex-1 flex justify-end items-center">
          <!-- 年度 -->
          <!-- <div class="mt-auto">
            <input
              type="number"
              min="2022"
              max="2999"
              placeholder="年度 検索"
              class="py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900 font-bold w-20 text-center" 
              v-model="year"
            /> 
            <span class="pl-1 pr-2 font-bold text-white text-sm">年度</span>
          </div> -->

          <!-- 契約中など -->
          <div class="mr-2">
            <select
              v-model="filter.cancel"
              class="border-gray-300 rounded py-1"
            >
              <option v-for="(status, i) in ['契約中', '解約済み', '全て']"
                :key="'s' + i"
                :value="status"
              >
                {{ status }}
              </option>
            </select>
          </div>

          <!-- 物件名 -->
          <div class="mr-2 mt-auto">
            <input
              v-tooltip="'スペースでアンド検索します'"
              type="search"
              placeholder="物件名 もしくは カナ"
              class="border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900"
              v-model="filter.site"
            /> 
          </div>

          <!-- 得意先名 -->
          <div class="mr-2 mt-auto">
            <input
              type="search"
              placeholder="得意先名"
              class="border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900"
              v-model="filter.client"
            /> 
          </div>

          <div class="mr-2">
            <PrimaryButton text="検索" size="normal" @click="getData(1)" />
          </div>

          <Icon 
            iconName="Refresh" 
            :clickable="false" 
            :class="{'animate-spin': loading}" 
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
            @click.native="refresh"
          />
        </div>
      </template>
      <!-- <template #page-header-content>
      </template> -->
    </PageHeader>

    <main class="absolute top-20 w-screen bottom-4 -mt-2 leading-8">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto main">
          <table class="text-sm w-full">
            <thead class="th sticky top-0 z-20 text-xs text-gray-700">
              <tr class="column">
                <th v-for="(c, i) in column" :key="'col'+i" class="p-2 text-left whitespace-pre-line">
                  {{ c.name }}
                </th>
              </tr>
            </thead>
            <tbody v-for="(row, index) in list" :key="index">
              <tr :class="setColor(index, row.cancel)" class="hover-color text-sm text-gray-800 cursor-pointer" @click="edit(row)">
                <td class="p-2 text-xs">
                  <div v-if="row.cancel" class="font-bold text-green-700 text-sm">解約済み</div>
                  <div>{{ row.siteCode }}</div>
                </td>
                <td class="p-2 font-bold">
                  <div>{{ row.nameSite1 }}</div>
                  <div>{{ row.nameSite2 }}</div>
                </td>
                <td class="p-2">
                  <div>{{ row.client1 }}</div>
                  <div class="text-gray-600 mt-1">{{ row.client2 }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="my-3 w-fit mx-auto">
          <pagination id="pagenation" v-model="page" :per-page="perPage" :records="records" class="text-center" @paginate="getData()" />
        </div>

      </div>
    </main>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import Pagination from 'vue-pagination-2'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as backend from '@libs/backend'
// import * as moment from 'moment'
import PageModel from '../../main/pages/PageModel.vue'

const settionStrageName = 'sitOutlineStrage'

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    Pagination,
    PrimaryButton
  },

  data() {
    return {
      loading: false,
      // 検索
      filter: {
        site:  '',
        client: '',
        cancel: '契約中'
      },
      // カラム
      column: [
        { name: '物件コード' },
        { name: '物件名１\r\n物件名２' },
        { name: '得意先名\r\n支店名' },
        // { name: '' },
      ],
      // データ
      list: [],
      // 表示年度
      // year: Number(moment().add(-2, 'months').format('YYYY')),
      // ページ数
      page: 1,
      // １ページの最大件数
      perPage: 50,
      // 全件数
      records: 0
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.getSettionStrage()
      this.getData(1)
    })
  },

  computed: {
  },

  methods: {
    /**
     * データ取得
     */
    async getData(num) {
      this.loading = true
      this.setSessionStorage()
      if (num) {
        this.page = num
      }
      let res = await backend.searchData('siteOutline/getList', { perPage: this.perPage, page: this.page, ...this.filter })
      this.list = res.data.data
      if (!this.list.length) {
        this.records = 0
      } else {
        this.records = Number(this.list[0].totalSize)
      }
      this.loading = false
    },

    /**
     * 背景色設定
     */
    setColor(i, cancel) {
      if (this.filter.cancel == '全て') {
        if (cancel) {
          return 'bg-gray-200'
        }
        if (i % 2 != 0) {
          return 'bg-blue'
        } else {
          return ''
        }
      } else {
        if (i % 2 != 0) {
          return 'bg-blue'
        } else {
          return ''
        }
      }
    },

    /**
     * 編集イベント
     * @param data 編集内容
     */
    edit(data) {
      let resolvedRoute = this.$router.resolve({ 
        name: 'SiteOutlineEdit',
        query: {
          siteCode: data.siteCode
        }
      })
      window.open(resolvedRoute.href, '_blank')
    },

    /**
     * セッションストレージ取得
     */
    getSettionStrage() {
      const searchJson = sessionStorage.getItem(settionStrageName)
      const getItem = JSON.parse(searchJson)
      if (getItem) {
        if (getItem.type) {
          this.year = getItem.year
        }
        delete getItem.year
        this.filter = getItem
        if (!this.filter.cancel) {
          this.filter.cancel = '契約中'
        }
      }
    },

    /**
     * セッションストレージ保存
     */
    setSessionStorage() {
      const searchStr = JSON.stringify({ ...this.filter, year: this.year })
      sessionStorage.setItem(settionStrageName, searchStr)
    },
  }
}
</script>

<style scoped>
.min-w-1000px {
  min-width: 1000px;
}

.main {
  height: calc(100% - 67px);
  min-width: 980px;
}

.column th {
  background: #edecf7;
}

.bg-blue {
  background: rgb(243 247 249);
}

.hover-color:hover {
  background: rgba(184, 244, 242, 0.67);
}

#pagenation >>> ul {
  display: flex !important;
  color: rgb(6, 125, 194);
  font-weight: bold !important;
  cursor: pointer;
}

#pagenation >>> ul > li {
  padding: 0 10px;
}

#pagenation >>> ul > .active {
  background: rgb(6, 125, 194);
  color: white;
}

#pagenation >>> p {
  color: gray;
  font-size: small;
}

</style>